<template lang="pug">
  .shopping-cart
    component.cart-summary(
        v-if="force || (qty && cart.articlePivots && cart.articlePivots.length)"
        :is="cartComponent.is"
        v-bind="cartComponent.props"
    )
      span.icon.is-medium(v-if="qty > 0 && qty < 100")
        i.fas.fa-shopping-cart
      span.pill(v-if="qty > 0 && qty < 100") {{ qty }}
      span.pill.much(v-else-if="qty > 0 && qty >= 100")
        span.limited 99+
        span.full {{ qty }}
      span.price(:class="{ 'min-amount' : grandTotal < 100 }") {{ grandTotal | moneyFormat(currency) }}

    span.icon.is-medium(v-if="sidebar && qty == 0" :is="cartComponent.is" v-bind="cartComponent.props")
        i.fas.fa-shopping-cart


</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { get } from '@/helpers';
// import { moneyFormat } from '@/filters';

export default {
    name: 'ShoppingCart',
    props: {
        sidebar: {
            type: Boolean,
            default: false
        },
        force: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        qty() {
            return get(this.cart, 'qty') || 0;
        },
        // tax() {
        //   const tax = get(this.cart, 'tax') || 0;
        //
        //   const code =
        //     get(this.customer, 'customerGroup.currency.iso4217') ||
        //     get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        //     'EUR';
        //
        //   return moneyFormat(tax, code);
        // },
        // price() {
        //   let sum = get(this.cart, 'sum') || 0;
        //
        //   if (this.customer && get(this.customer, 'show_net_prices')) {
        //   // if (this.customer && get(this.customer, 'tax_free')) {
        //     const tax = get(this.cart, 'tax') || 0;
        //     sum -= tax;
        //   }
        //
        //   const code =
        //     get(this.customer, 'customerGroup.currency.iso4217') ||
        //     get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
        //     'EUR';
        //
        //   return moneyFormat(sum, code);
        // },
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        checkoutRoute() {
            let path;
            this.cms.menus.forEach(menu => {
                const item = menu.menuItems.find(item => get(item, 'page.view') === 'Checkout');
                if (item && item.path && !path) {
                    path = item.path;
                    return;
                }
            });
            return path;
        },
        cartComponent() {
            let cartComponent = {
                is: 'div',
                props: {
                    title: "Bitte beachten Sie unseren Mindestbestellwert von 100 €"
                },
            };
            if (this.checkoutRoute) {
                cartComponent.is = 'router-link';
                cartComponent.props.to = this.checkoutRoute;
            }
            return cartComponent;
        },
        ...mapGetters({
            cms: 'CMS',
            member: 'auth/member',
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            // shippingFee: 'shop/shippingFee',
            grandTotal: 'shop/grandTotal',
            cart: 'shop/cart',
            menus: 'menus'
        })
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.cart-summary
    @apply flex items-center flex-row relative ml-4 h-full
    line-height: 56px
    .price
        @apply relative
        top: -1px
        &.min-amount
            @apply text-red-800
    .icon
        @apply items-center inline-flex justify-center w-8 h-8
    .pill
        @apply relative inline-block cursor-default text-xs text-white text-center bg-red-600 leading-none font-bold rounded-full
        height: 14px
        top: -10px
        left: -15px
        padding: 1px 3px
        margin-right: -10px
        &.much
          .limited
            @apply inline
          .full
            @apply hidden
          &:hover
            .limited
              @apply hidden
            .full
              @apply inline
</style>
